module.exports = __webpack_public_path__ + "static/media/socrypto-large-black.23669b02.svg";